import { Pagination } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { read_patient_profile } from "../../actions/InterBranchCoordinatorAction"
// import { PATIENT_DETAILS_MODAL_NAME } from '../../Redux/Const';
// import { setModalRedux } from '../../Redux/Slice/ModalSlice';
import PatientAppointmentDetailsInDetail from './Components/PatientAppointmentDetailsInDetail/PatientAppointmentDetailsInDetail';
import './patientdetails.css'

function PatientDetails() {

    let dispatch = useDispatch()

    // const { selectedAppointment } = useSelector((state) => state.patientDetailsRedux)
    let reduxData = useSelector(state => state) ; 
    console.log("Redux Data in PatientDetails.jsx: ",reduxData);

    let patientId = reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;
    console.log("Registered patient id is: ",patientId);



    let handleTableClick = () => {

        // dispatch(setModalRedux({
        //     name: PATIENT_DETAILS_MODAL_NAME,
        //     value: true
        // }))

        try {
            //IMPORTANT!!!!!Pass the selected patient's id instead of passing the registered patient id
            dispatch(read_patient_profile(patientId)); 
        }catch (error) {
            console.log("Error in read_patient_profile API",error);
        } 

    }




    return (
        <div className='appontment-history-container'>

            {
                // selectedAppointment ?

                //     <PatientAppointmentDetailsInDetail />

                //     :
                    <>
                        <div className="header">
                           
                            <div className="filter-button">
                                <div className="icon">&nbsp;</div>
                                Filter Appointments
                            </div>

                        </div>

                        <table className='custom-table'>
                            <tr>
                                <th>Patient ID</th>
                                <th>Patient Name</th>
                                <th>Mobile Number</th>
                                <th>Registered on</th>
                                <th>Registered on</th>
                                <th></th>
                            </tr>

                            <tbody>
                                <tr>
                                    <td >123456789</td>
                                    <td >Jane Dow</td>
                                    <td >+91 123456789</td>
                                    <td >01, January, 2022</td>
                                    <td >01, January, 2022</td>
                                    <td  ><button onClick={handleTableClick} className='more-btn' >More</button></td>

                                </tr>

                                <tr>
                                    <td >123456789</td>
                                    <td >Jane Dow</td>
                                    <td >+91 123456789</td>
                                    <td >01, January, 2022</td>
                                    <td >01, January, 2022</td>
                                    <td  ><button onClick={handleTableClick} className='more-btn' >More</button></td>

                                </tr>

                                <tr>
                                    <td >123456789</td>
                                    <td >Jane Dow</td>
                                    <td >+91 123456789</td>
                                    <td >01, January, 2022</td>
                                    <td >01, January, 2022</td>
                                    <td  ><button onClick={handleTableClick} className='more-btn' >More</button></td>

                                </tr>

                                <tr>
                                    <td >123456789</td>
                                    <td >Jane Dow</td>
                                    <td >+91 123456789</td>
                                    <td >01, January, 2022</td>
                                    <td >01, January, 2022</td>
                                    <td  ><button onClick={handleTableClick} className='more-btn' >More</button></td>

                                </tr>
                            </tbody>
                        </table>

                        <div className="pagination-container">
                            <Pagination defaultCurrent={6} total={500} />
                        </div>
                    </>
            }

        </div>
    )
}

export default PatientDetails;
